import { FC } from 'react';
import { useParams } from 'react-router-dom';

import { compose } from '@reduxjs/toolkit';
import { ErrorContainer } from 'components/common/ErrorContainer';
import { useUserFunctionality } from 'hooks';
import { GlobalFooterContainer } from 'portfolio3/containers/footers';
import { GlobalHeaderContainer } from 'portfolio3/containers/headers';

import { withRendererType } from '../hocs';

const ErrorsRenderer: FC = () => {
  const { code } = useParams<{ code?: string }>();

  const { isStudent } = useUserFunctionality();

  return (
    <>
      <GlobalHeaderContainer isFullWidth />
      <ErrorContainer errorCode={Number(code)} userRole={isStudent ? 'child' : 'adult'} />
      <GlobalFooterContainer isFullWidth />
    </>
  );
};

export default compose<FC>(withRendererType('errors'))(ErrorsRenderer);
